import React from 'react'
import { Button } from 'react-bootstrap';
import { descargarDatos } from '../../functions/descargarDatos'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export const Descarga = ({programa, proceso}) => {

    const descargar = () => {
        
        const datos = descargarDatos(programa, proceso);

        datos.then((data) => {
            
            const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = "xlsx";

            const ws = XLSX.utils.json_to_sheet(data);
            const wb = {
                Sheets: {data: ws},
                SheetNames: ["data"]
            };

            const excelBuffer = XLSX.write(wb, {bookType: "xlsx", type: "array"});
            const d_data = new Blob([excelBuffer], {type: fileType});
            FileSaver.saveAs(d_data, "tablero", fileExtension); 

        })
        
    }

    return (
        <Button block variant="secondary" onClick={descargar}>Descargar corte</Button>
    )
}
